import React, { useEffect, useState } from "react";
import { getAllCategories } from "../services/categoryService";
import { useNavigate } from "react-router-dom";

const FooterCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getAllCategories();
        if (data.success) {
          setCategories(data.categories);
        } else {
          console.error("Failed to fetch categories");
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (categorySlug) => {
    navigate(`/${categorySlug}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    
      <div className="footer-widget">
        <h3 className="title">Categories</h3>
        {loading ? (
          <div className="text-center py-3">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : categories.length > 0 ? (
          <ul>
            {categories.map((category) => (
              <li key={category.slug}>
                <a href="#" onClick={() => handleCategoryClick(category.slug)}>
                  {category.name}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-muted py-3">No categories found.</div>
        )}
      </div>
    
  );
};

export default FooterCategories;
